<template>
  <div id="data-view">
    <dv-full-screen-container>

      <top-header @toggle="toggle"/>

      <template v-if="pageNum ===0">
        <div class="main-content">
          <digital-flop/>

          <div class="block-left-right-content">
            <!--<ranking-board />-->

            <div class="block-top-bottom-content">
              <div class="block-top-content">
                <!--<rose-chart />-->
                <income></income>


                <water-level-chart/>

                <vacancy-rate/>

                <scroll-board/>
              </div>

              <cards/>
            </div>
          </div>
        </div>
      </template>

      <template v-if="pageNum ===1">
          <div class="row">
            <div class="col-md-6">
              <focus-groups/>
              <!--<div class="col6"></div>-->
            </div>

            <div class="col-md-3">
              <finance/>
              <!--<div class="col3"></div>-->
            </div>

            <div class="col-md-3">
              <pie-chat/>
              <!--<div class="col3"></div>-->
            </div>

        </div>
      </template>


    </dv-full-screen-container>
  </div>
</template>

<script>
import topHeader from './topHeader'
import digitalFlop from './digitalFlop'
import rankingBoard from './rankingBoard'
import roseChart from './roseChart'
import waterLevelChart from './waterLevelChart'
import scrollBoard from './scrollBoard'
import cards from './cards'
import vacancyRate from './vacancyRate.vue'
import income from './income.vue'
import focusGroups from '@/components/page2/focusGroups.vue'
import finance from '@/components/page2/finance.vue'
import pieChat from '@/components/page2/pieChat.vue'

export default {
  name: 'DataView',
  components: {
    topHeader,
    digitalFlop,
    rankingBoard,
    roseChart,
    waterLevelChart,
    scrollBoard,
    cards,
    vacancyRate,
    income,
    focusGroups,
    finance,
    pieChat

  },
  data () {
    return {
      pageNum: 0
    }
  },
  methods: {
    toggle (pageNum) {
      console.log(pageNum)
      this.pageNum = pageNum
    }
  }
}
</script>

<style lang="less">
#data-view {
  width: 100%;
  height: 100%;
  background-color: #030409;
  color: #fff;

  #dv-full-screen-container {
    background-image: url('./img/bg.png');
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }

  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .block-left-right-content {
    flex: 1;
    display: flex;
    margin-top: 20px;
  }

  .block-top-bottom-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding-left: 20px;
  }

  .block-top-content {
    height: 55%;
    display: flex;
    flex-grow: 0;
    box-sizing: border-box;
    padding-bottom: 20px;
  }
}
.col6 {
  height: 200px;
  background: #03d3ec;
}
.col3 {
  height: 200px;
  background-color: #f46827;
}
</style>
